import { useLazyGetInvoicePdfQuery } from '../Service/extendedInvoicesApi';

export const downloadInvoicePdf = async (
  triggerGetPdf: ReturnType<typeof useLazyGetInvoicePdfQuery>[0],
  invoiceId: number,
  fileName: string
): Promise<void> => {
  const pdfBlob = await triggerGetPdf(invoiceId).unwrap();

  if (!(pdfBlob instanceof Blob) || pdfBlob.size === 0) {
    throw new Error('Downloaded invoice PDF is empty.');
  }

  const url = window.URL.createObjectURL(pdfBlob);

  try {
    const link = window.document.createElement('a');
    link.href = url;
    link.download = fileName;
    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);
  } finally {
    window.URL.revokeObjectURL(url);
  }
};
